var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('show-status',{attrs:{"value":_vm.value,"config":{
    0: { label: 'Aguardando', color: '#FF9800' },
    1: { label: 'Executado', color: '#4CAF50' },
    2: { label: 'Cancelado', color: '#F44336' },
    3: { label: 'Enviado', color: '#2196F3' },
    4: { label: 'Não Enviado', color: '#949494' },
    5: { label: 'Expirado', color: '#545454' },
  }}})}
var staticRenderFns = []

export { render, staticRenderFns }